/**
 * Events Carousel Module
 * Slide article by article
 * 
 * @package JD_Theme
 */

export function initEventsCarousel() {
  const carousel = document.querySelector('.events-carousel');
  const prevBtn = document.querySelector('.carousel-btn-prev');
  const nextBtn = document.querySelector('.carousel-btn-next');

  if (!carousel || !prevBtn || !nextBtn) return;

  const cards = carousel.querySelectorAll('.event-card');
  if (cards.length === 0) return;

  let currentIndex = 0;
  let cardPositions = [];

  function calculatePositions() {
    // Calculate the exact position of each card using offsetLeft
    cardPositions = [];
    
    cards.forEach((card) => {
      // Use offsetLeft to get the real position of each card
      cardPositions.push(card.offsetLeft);
    });
  }

  function updateCarousel() {
    const position = cardPositions[currentIndex] || 0;
    carousel.style.transform = `translateX(-${position}px)`;
    carousel.style.transition = 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    
    // Update buttons state
    prevBtn.disabled = currentIndex <= 0;
    nextBtn.disabled = currentIndex >= cards.length - 1;
    
    // Visual feedback
    if (prevBtn.disabled) {
      prevBtn.style.opacity = '0.5';
      prevBtn.style.cursor = 'not-allowed';
    } else {
      prevBtn.style.opacity = '1';
      prevBtn.style.cursor = 'pointer';
    }
    
    if (nextBtn.disabled) {
      nextBtn.style.opacity = '0.5';
      nextBtn.style.cursor = 'not-allowed';
    } else {
      nextBtn.style.opacity = '1';
      nextBtn.style.cursor = 'pointer';
    }
  }

  prevBtn.addEventListener('click', () => {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  });

  nextBtn.addEventListener('click', () => {
    if (currentIndex < cards.length - 1) {
      currentIndex++;
      updateCarousel();
    }
  });

  // Recalculate positions on window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      calculatePositions();
      // Ensure current index is still valid
      if (currentIndex >= cards.length) {
        currentIndex = cards.length - 1;
      }
      updateCarousel();
    }, 150);
  });

  // Initialize
  calculatePositions();
  updateCarousel();
}
